import { Button, Group, Modal, Paper, Select, TextInput, Title } from '@mantine/core';
import { showNotification } from '@mantine/notifications';
import React from 'react';
import { FaNetworkWired } from 'react-icons/fa';
import SimpleHeader from '../components/simple_header';
import Table from '../components/table';
import { useAuth } from '../contexts/auth.context';
import { SAVE_CUSTOMER, GET_ALL_CUSTOMERS, DELETE_CUSTOMER } from '../services/customers';
import { useApp } from '../contexts/app.context';

export default function CompaniesPage(){
    const [modal, setModal] = React.useState(null);

    const listRef = React.useRef<any>();

    const [loading, setLoading] = React.useState(false);
    const [loadingSave, setLoadingSave] = React.useState(false);
    const [error, setError] = React.useState<any>(null);
    const [data, setData] = React.useState([]);
    const [invites, setInvites] = React.useState([]);

    const { onChangeCompany, companies } = useAuth();
    const { confirmDialog } = useApp();

    const loadCompanies = () => {
        setLoading(true);

        GET_ALL_CUSTOMERS()
        .then(companies => {
            setLoading(false);
            setData(companies.sort((a,b) => a.name > b.name ? 1 : -1));
        })
        .catch(err => {
            setLoading(false);
            showNotification({message: err.message, color: 'red'});
        })
    }

    const refresh = () => { 
        loadCompanies();
    }

    const handleSave = () => {
        setLoadingSave(true);
        SAVE_CUSTOMER(modal)
        .then(() => {
            setLoadingSave(false)
            refresh();
            setModal(null);
        })
        .catch(err => {
            setLoadingSave(false);
            showNotification({message: err.message, color: 'red'});
        })
    }
    
    const deleteCustomer = (customerId) => {
        setLoadingSave(true);
        DELETE_CUSTOMER(customerId)
        .then(() => {
            setLoadingSave(false)
            refresh();
            setModal(null);
        })
        .catch(err => {
            setLoadingSave(false);
            showNotification({message: err.message, color: 'red'});
        })
    }

    React.useEffect(refresh, []);

    return <>
        <SimpleHeader title="Clientes" Icon={FaNetworkWired} />
        
        <Paper p="sm" mt="md">
            <Table 
                data={data}
                columns={[
                    { title: "Nome", key: "name" },
                    { title: "CNPJ/CPF", key: "cnpj" },
                    { title: "Endereço", key: "address", render: (item) => [
                        item?.address?.address,
                        item?.address?.complement,
                        item?.address?.neighborhood,
                        item?.address?.city,
                        item?.address?.uf,
                        item?.address?.number,
                        item?.address?.cep,
                    ].filter(nn => nn).join(", ")},
                ]}
                error={error}
                loading={loading}
                actions={[
                    {
                        title: "Navegar", 
                        onClick: ({item}) => { onChangeCompany(item._id, true) }
                    },
                    {
                        title: "Editar", 
                        color: "yellow",
                        onClick: ({item}) => { setModal({ ...item, id: item._id }) }
                    },
                    {
                        title: "Deletar",
                        color: "red",
                        onClick: ({ item }) => {
                            confirmDialog(
                                {text: "Realmente deseja excluir esse cliente?"},
                                (({confirmed}) => { if(confirmed) deleteCustomer(item._id); })
                            )
                        }
                    }
                ]}
            />
        </Paper>

        <Modal
            opened={!!modal}
            onClose={() => setModal(null)}
        >
            <Select
                mt="md"
                label="Tipo da empresa"
                name="type"
                value={modal?.type}
                onChange={type => setModal(fd => ({ ...fd, type }))}
                data={[
                  {label: "Empresa Privada", value: "empresa-privada"},
                  {label: "Órgão Público", value: "orgao-publico"},
                  {label: "Frente Parlamentar", value: "frente-parlamentar"},
                  {label: "Parlamentar", value: "parlamentar"},
                  {label: "Partido Político", value: "partido"},
                  {label: "Outros", value: "outro"},
                ]}
            />
            <TextInput mt="md" label="Nome" name="name" value={modal?.name} onChange={(e) => setModal(m => ({ ...m, name: e.target.value }))} />
            <TextInput mt="md" label="CNPJ/CPF" name="cnpj" value={modal?.cnpj} onChange={(e) => setModal(m => ({ ...m, cnpj: e.target.value }))} />
            <TextInput mt="md" label="Telefone ou celular" name="phone" value={modal?.phone} onChange={(e) => setModal(m => ({ ...m, phone: e.target.value }))} />
            <TextInput mt="md" label="E-mail" name="email" type="email" value={modal?.email} onChange={(e) => setModal(m => ({ ...m, email: e.target.value }))} />
            <Title order={5} mt="md">Endereço</Title>
            <TextInput mt="md" label="CEP" name="cep" value={modal?.address?.cep} onChange={(e) => setModal(m => ({ ...m, address: {...m.address, cep: e.target.value} }))} />
            <Group>
                <TextInput mt="md" style={{flex: 0.3}} label="UF" name="uf" value={modal?.address?.uf} onChange={(e) => setModal(m => ({ ...m, address: {...m.address, uf: e.target.value} }))} />
                <TextInput mt="md" style={{flex: 0.7}} label="Cidade" name="city" value={modal?.address?.city} onChange={(e) => setModal(m => ({ ...m, address: {...m.address, city: e.target.value} }))} />
            </Group>
            <TextInput mt="md" label="Bairro" name="neighborhood" value={modal?.address?.neighborhood} onChange={(e) => setModal(m => ({ ...m, address: {...m.address, neighborhood: e.target.value} }))} />
            <TextInput mt="md" label="Endereço" name="address" value={modal?.address?.address} onChange={(e) => setModal(m => ({ ...m, address: {...m.address, address: e.target.value} }))} />
            <TextInput mt="md" label="Complemento" name="complement" value={modal?.address?.complement} onChange={(e) => setModal(m => ({ ...m, address: {...m.address, complement: e.target.value} }))} />
            <TextInput mt="md" label="Número" name="number" value={modal?.address?.number} onChange={(e) => setModal(m => ({ ...m, address: {...m.address, complement: e.target.value} }))} />

            <Group position='right' mt="lg">
                <Button disabled={loadingSave} onClick={() => setModal(null)} variant='outline' color="gray">Cancelar</Button>
                <Button loading={loadingSave} onClick={handleSave} variant='filled'>Salvar</Button>
            </Group>
        </Modal>
    </>
}
